import "../css/TwoColumnsImages.css";
import { useState } from "react";
import { Flex, Row, Col } from "antd";
import { useQuery } from "@apollo/client";
import ReactPlayer from 'react-player'
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl";
import isImageOrVideo from "../utils/isImageOrVideo";
import {
  GET_TWO_COLUMS_IMAGE_BY_SLUG,
} from "../queries";

const ShowMedia = ({mediaItemUrl}) => {
  const mediaType = isImageOrVideo(mediaItemUrl);
  if (mediaType === "image") {
    return (
      <div className="TwoColumnsImage-box TwoColumnsImage-image"
        style={{
          backgroundImage: `url(${setImageAbsoluteUrl(mediaItemUrl)})`,
        }}
      />
    );
  } else if (mediaType === "video") {
    return (
      <ReactPlayer
        className='react-player-rounded'
        url={setImageAbsoluteUrl(mediaItemUrl)}
        width='100%'
        height='auto'
        playing={true}
        volume={0}
        loop={true}
      />
    )
  }
}

const TwoColumnsImage = ({ page, section, lang }) => {  
  const slug = `${page}-${section}-${lang}`;
  console.log('slug', slug);
  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });

  const isHero = section.includes('hero');

  const { loading, error, data } = useQuery(GET_TWO_COLUMS_IMAGE_BY_SLUG, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.twocolumnsimage;  
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  }); 
  
  return (
    <>
    {
      sectionData && (
        <Flex className="TwoColumnsImage">
        {sectionData?.tituloTci && (
          <Row>
            <Col span={24}>
              <Flex className="TwoColumnsImage-title">
                <Flex vertical>
                  <h2
                    className="h4-headline-500"
                    dangerouslySetInnerHTML={{ __html: sectionData?.tituloTci }}
                  />
                </Flex>
              </Flex>
            </Col>
          </Row>
        )}
          <Row justify={'space-between'} gutter={32} className="TwoColumnsImage-content">
            <Col lg={12} md={24} xs={24} sm={24}>
              { sectionData?.imagenIzquierda?.node?.mediaItemUrl ? (
                <ShowMedia mediaItemUrl={sectionData?.imagenIzquierda?.node?.mediaItemUrl}/>
              ) :  (<>
                <div>  
                </div>
              </>)}
            </Col>
            <Col lg={12} md={24} xs={24} sm={24}>
              { sectionData?.imagenDerecha?.node?.mediaItemUrl ? (
                <ShowMedia mediaItemUrl={sectionData?.imagenDerecha?.node?.mediaItemUrl}/>
              ) : (
                <>
                  <div>  
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Flex>
      )
    }
    </>
  );
};

export default TwoColumnsImage;
